export const environment = {
  env: 'staging',
  authIssuer: 'https://proxy.staging.eosc-federation.eu',
  authClientID: 'APP-25749159-8EC6-4AC5-BF10-8497329FFE06',
  apiUrl: 'https://api.eosc.athenarc.gr',
  adminApiUrl: 'https://api.admin.eosc.athenarc.gr',
  skipAuthInitialization: false,
  isErrorHandlingTestingPageIncluded: true,
  isTokenRetrievalPageIncluded: true,
  toolApiEndpoint: '/tools/admin/action/v1',
  entitlementsPrefix: 'urn:geant:eosc-federation.eu',
  helpdeskFormURL: 'https://eunode-helpdesk-stage.scc.kit.edu',
  helpdeskGeneralGroupID: 2,
  helpDeskLOT2GroupId: 26,
  helpDeskLOT3GroupId: 27,
  helpdeskCustomResourcesGroupID: 6,
  helpdeskCreditVouchersId: 25,
  aaiRegistrationURL: 'https://webapp.staging.eosc-federation.eu/sp_request',
};
